import { Layer } from "./Layer";
export class DataProvider extends Layer {
    constructor(inLayer, dataKeys) {
        super(dataKeys);
        this.inLayer = inLayer;
    }
    activate() {
    }
    close() {
    }
    onDependencyAvailable(dep) {
        super.onDependencyAvailable(dep);
        // console.log(`${this.constructor.name}: OnDependencyAvailable (${dep})`);
    }
    onDependencyUnavailable(dep) {
        super.onDependencyUnavailable(dep);
        // console.log(`${this.constructor.name}: OnDependencyUnavailable (${dep})`);
    }
    update(inEvent) {
        return inEvent;
    }
    getLayerData() {
        return this.inLayer.data;
    }
}
//# sourceMappingURL=DataProvider.js.map